// services/userService.ts
import {
  fetchEmployees,
  getUserInfoByEmail,
} from "../../data_management/services/employeeService.tsx";
import { getAllOffices } from "../../data_management/services/officeService.tsx";

export interface ProfileData {
  id: string;
  name: string;
  email: string;
  roles: string;
  role: string;
  status: string;
  division: string;
  office: string;
  password: string;
}

export const getProfileData = async (email: string): Promise<ProfileData> => {
  if (!email) throw new Error("Email is required");

  try {
    // 1. Get user info first
    const userInfo = await getUserInfoByEmail(email);

    // 2. Get employees and offices data in parallel
    const [employees, offices] = await Promise.all([
      fetchEmployees(),
      getAllOffices(),
    ]);

    // 3. Find employee matching the email
    const employee = employees.find(
      (e) => e.email?.toLowerCase() === email.toLowerCase()
    );

    if (!employee) {
      console.warn(`Employee data not found for email: ${email}`);
    }

    // 4. Find office name based on employee.officeId
    const office = employee?.office
      ? offices.find((o) => o.officeId === employee.office)
      : undefined;

    // 5. Format data with fallbacks
    return {
      id: userInfo.id || "",
      name: employee?.name || userInfo.username || "N/A",
      email: email,
      roles: userInfo.roles?.join(", ") || "N/A",
      status: employee?.status || "N/A",
      role: employee?.position
        ? JSON.parse(employee.position).join(", ")
        : "N/A", // Parse the array string
      division: employee?.division || "N/A",
      office: office?.officeName || employee?.office || "N/A", // Use office name if found
      password: "********",
    };
  } catch (error) {
    console.error("Error in getProfileData:", error);
    throw error;
  }
};

export const saveProfileData = (data: ProfileData) => {
  localStorage.setItem("userProfileData", JSON.stringify(data));
};

export const loadProfileData = (): ProfileData | null => {
  const data = localStorage.getItem("userProfileData");
  return data ? JSON.parse(data) : null;
};
